// Temporary Room Type Service & Model

export class DateRange {
    dateStart: string;
    dateEnd: string;
}

export class Sleeps {
    adult: number;
    children: number;
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/room-availability-v2/room-mock.service.ts